const BREADCRUMB = ['51擦边', '专题解读', '内容审核参考'];

const QUICK_TOPICS = ['审核标准', '尺度边界', '违规案例', '下架原因'];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[600px]">
      {/* 背景图 + 遮罩 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=minimal%20editorial%20magazine%20cover%20backdrop%20in%20warm%20ivory%20paper%20tone%20with%20abstract%20vermilion%20red%20ink%20brush%20strokes%20and%20geometric%20ribbon%20shapes%2C%20generous%20soft%20negative%20space%2C%20high%20end%20print%20design%20feel%2C%20muted%20warm%20palette%2C%20no%20text%2C%20soft%20natural%20lighting%2C%20sophisticated%20layered%20composition&width=1600&height=900&seq=51c-hero-01&orientation=landscape"
          alt="51擦边审核专题封面背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/25" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-20 md:px-6 md:py-28">
        <div className="max-w-3xl">
          <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-accent-200 md:text-sm">
            <i className="ri-flashlight-line text-base" />
            {BREADCRUMB.join(' · ')}
          </p>

          <h1 className="mt-5 font-serif text-3xl font-black leading-tight text-background-50 md:text-5xl md:leading-snug">
            看懂<span className="text-accent-300">51擦边审核标准</span>
            <br />
            先把尺度边界、违规案例、下架原因弄清楚
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-50/85 md:text-lg">
            平台每天都在判定哪些内容越线、哪些要被整改。我们把审核标准拆开讲：从视觉表现到话术引导，
            从一次限流到永久下架，到底踩在哪条线上会翻车——吃瓜之前，先自己心里有数。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#boundary"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:text-base"
            >
              先看尺度边界
              <i className="ri-arrow-right-down-line text-base" />
            </a>
            <a
              href="#cases"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/20 md:text-base"
            >
              翻违规案例
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {QUICK_TOPICS.map((t) => (
              <span
                key={t}
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-accent-200/40 bg-foreground-950/40 px-3.5 py-1.5 text-xs text-accent-100 md:text-sm"
              >
                <i className="ri-price-tag-3-line text-accent-300 text-xs" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}